type PaymentResultStatusIconProps = {
    status: 'success' | 'fail'
}

export const PaymentResultStatusIcon = ({ status }: PaymentResultStatusIconProps) => {
    const isSuccess = status === 'success'

    return (
        <div className={`payment-result-status payment-result-status--${status}`} aria-hidden='true'>
            <span className='payment-result-status__ring' />
            <span className='payment-result-status__ring payment-result-status__ring--delayed' />
            <svg className='payment-result-status__svg' viewBox='0 0 52 52' role='presentation'>
                <circle className='payment-result-status__circle' cx='26' cy='26' r='24' />
                {isSuccess ? (
                    <path className='payment-result-status__mark' d='M14.5 27.2 L22.2 34.5 L37.5 18.5' />
                ) : (
                    <>
                        <path className='payment-result-status__mark' d='M18 18 L34 34' />
                        <path
                            className='payment-result-status__mark'
                            style={{ animationDelay: '0.55s' }}
                            d='M34 18 L18 34'
                        />
                    </>
                )}
            </svg>
        </div>
    )
}
